import ContactForm from '../components/ContactoForm/ContactoForm';

const Contact = () => {


    return (
        <div style={{ backgroundColor: '#F5F5DC', padding: '2rem', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#F5F5DC', height: "20%", width: "20%", borderRadius: "10px", margin: "20px auto" }}>
                <ContactForm />
                 </div>
        </div>
    );
};

export default Contact;